import { EBannerType } from 'shared/constants/banner';

import { EBannerRotationActionTypes } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const setBannerRotation = actionGenerator<EBannerRotationActionTypes.SetBanner, EBannerType>(
  EBannerRotationActionTypes.SetBanner,
);
